import { log } from "./logUtils";
import Axios from "axios";

export const makeNetworkRequest = async (httpRequestType, endPoint, authorizationToken, postData) => {
    let url = `${process.env.REACT_APP_BACKEND_URL}`;
    try {
        let response = "";
        if(authorizationToken) {
            if(httpRequestType === "post") {
                response = await Axios.post(`${url}${endPoint}`, postData, { "headers": { "Authorization": `Bearer ${authorizationToken}` }});
            } else if(httpRequestType === "delete") {
                response = await Axios.delete(`${url}${endPoint}`, { "headers": { "Authorization": `Bearer ${authorizationToken}` }});
            } else {
                response = await Axios.get(`${url}${endPoint}`, { "headers": { "Authorization": `Bearer ${authorizationToken}` }});
            }
        } else {
            if(httpRequestType === "post") {
                response = await Axios.post(`${url}${endPoint}`, postData);
            } else if(httpRequestType === "delete") {
                response = await Axios.delete(`${url}${endPoint}`);
            } else {
                response = await Axios.get(`${url}${endPoint}`);
            }
        }
        // console.log(response);

        if(response && response.data && response.data.body) {
            return(JSON.parse(response.data.body));
        } else if(response && response.data) {
            return response.data;
        } else {
            return false;
        }
    } catch (error) {
        log("Network Request Error:", error, false, true);
        return false;
    }
};